import { useTranslation } from 'react-i18next';
import { CheckCircle2 } from 'lucide-react';
import styles from './PaymentReceivedPage.module.css';

interface Props { onNavigate: (path: string) => void }

/** Where a payment made on a Stripe-hosted page returns. */
export const PAYMENT_RECEIVED_PATH = '/payment-received';

/**
 * /payment-received: the thank-you page a Stripe Payment Link returns to once
 * the payment went through (after_completion redirect). The first user is the
 * pay link for the failed v1 card payments (Warren, 23 October 2026: "Pay-link
 * page for the 80 failed v1 payments: Stripe-hosted"; scripts/v1-paylink-emails.ts).
 *
 * Public, like /email-preferences: the payer may open the link on a device
 * that is not signed in, and paying never needs a sign-in, so thanking them
 * must not either. It reads nothing from the URL and calls nothing: Stripe
 * only redirects here after a completed card payment, and the session is
 * marked collected by the reconcile step, never by this page.
 */
export function PaymentReceivedPage({ onNavigate }: Props) {
  const { t } = useTranslation('paymentReceived');
  return (
    <div className={styles.page}>
      <div className={styles.column}>
        <p className={styles.brand}>EV INITIATIVE</p>
        <CheckCircle2 className={styles.icon} size={40} aria-hidden="true" />
        <h1 className={styles.title}>{t('title')}</h1>
        <p className={styles.intro}>{t('body')}</p>
        <p className={styles.intro}>{t('questions')}</p>
        <a
          className={styles.link}
          href="/"
          onClick={(e) => { e.preventDefault(); onNavigate('/'); }}
        >
          {t('openApp')}
        </a>
      </div>
    </div>
  );
}
